import {IResponseEntity} from '@toolify/server/src/services/EntityService/types/IResponseEntity'
import {EntityType} from '@toolify/server/src/services/EntityService/enum/EntityType'
import {getGuestDisplayInfo} from './getGuestDisplayInfo'

export function getEntityInitialsByEntity(entity: IResponseEntity) {
  if(!entity) {
    return ''
  }
  if(entity.entityType === EntityType.User) {
    const userEntity = entity as IResponseEntity<EntityType.User>
    const user = userEntity.payload

    if(!user?.nick) {
      return ''
    }
    const words = user.nick.split(/\s+/)
    if(words.length > 1) {
      return `${words[0].charAt(0)}${words[1].charAt(0)}`.toUpperCase()
    }
    
    if(/^[A-Za-z]+\d+$/.test(user.nick)) {
      return user.nick.replace(/[^A-Za-z]/g, '').substring(0, 2).toUpperCase()
    }
    
    return (
      user.nick.length > 1
        ? user.nick.substring(0, 2)
        : user.nick.charAt(0)
    ).toUpperCase()
  }
  if(entity.entityType === EntityType.Bot) {
    return ''
  }
  if(entity.entityType === EntityType.Guest) {
    return getGuestDisplayInfo((entity as IResponseEntity<EntityType.Guest>).entityId).initials
  }
  if(entity.entityType === EntityType.App) {
    const appEntity = entity as IResponseEntity<EntityType.App>
    const label = (appEntity.payload?.name || appEntity.payload?.key || '').trim()
    if(!label) {
      return ''
    }
    const words = label.split(/\s+/)
    if(words.length > 1) {
      return `${words[0].charAt(0)}${words[1].charAt(0)}`.toUpperCase()
    }
    return (
      label.length > 1
        ? label.substring(0, 2)
        : label.charAt(0)
    ).toUpperCase()
  }
  if(entity.entityType === EntityType.Agent) {
    const agentPayload = (entity as IResponseEntity<EntityType.Agent>).payload as {title?: string|null; name?: string}
    const label = ((agentPayload?.title || agentPayload?.name) ?? '').trim()
    if(!label) {
      return ''
    }
    const words = label.split(/\s+/)
    if(words.length > 1) {
      return `${words[0].charAt(0)}${words[1].charAt(0)}`.toUpperCase()
    }
    return (
      label.length > 1
        ? label.substring(0, 2)
        : label.charAt(0)
    ).toUpperCase()
  }
  return ''
}
